import Route from '@ember/routing/route'

export default class BookingStartV2Route extends Route {}
